<div class="custom-form-array" [formGroup]="form">
  <div class="custom-form-array__title array-title" *ngIf="item?.placeholder">
    {{ item.placeholder && item.placeholder !== 'undefined' ? item.placeholder : '' }}:
  </div>

  <ng-container [formArrayName]="item.formControlName">
    <div
      class="row arrRow custom-form-array__row"
      *ngFor="
          let controls of form?.controls[item.formControlName][
            'controls'
          ];
          let i = index
        "
      [formGroupName]="i"
    >
      <div class="custom-form-array__row-inputs row">
        <ng-container *ngFor="let control of item.arrSmartList">
          <div
            class="custom-form-field"
            *ngIf="control.type === 'text'"
            [ngClass]="control.gridClasses"
          >
            <mfpc-text-input
              formField
              [form]="controls"
              [item]="control"
              [formData]="formData"
            ></mfpc-text-input>
          </div>

          <div
            class="custom-form-field"
            *ngIf="control.type === 'textarea'"
            [ngClass]="control.gridClasses"
          >
            <mfpc-textarea
              formField
              [item]="control"
              [form]="controls"
            ></mfpc-textarea>
          </div>

          <div
            class="custom-form-field"
            *ngIf="control.type === 'select-filter'"
            [ngClass]="control.gridClasses"
          >
            <mfpc-select-filter
              formField
              [item]="control"
              [form]="controls"
              [options]="
                control?.optionListRequestAlias &&
                optionList &&
                optionList[control?.optionListRequestAlias]
                  ? controlsFilterOptionList[control.formControlName]
                    || optionList[control?.optionListRequestAlias].optionList
                  : controlsFilterOptionList[control.formControlName]
                    || control.optionList
              "
            ></mfpc-select-filter>
          </div>

          <div
            class="custom-form-field"
            *ngIf="control.type === 'datepicker'"
            [ngClass]="control.gridClasses"
          >
            <mfpc-datepicker
              formField
              [item]="control"
              [form]="controls"
              [formData]="formData"
              [min]="
              item.startDateMathDay || item.startDateMathDay === 0
                  ? mathCurrentDateDay(item.startDateMathDay)
                  : ''
              "
              [max]="
              item.endDateMathDay || item.endDateMathDay === 0
                  ? mathCurrentDateDay(item.endDateMathDay)
                  : ''
              "
            ></mfpc-datepicker>
          </div>

          <div
            class="custom-form-field"
            *ngIf="control.type === 'datepicker-range-start'"
            [ngClass]="control.gridClasses"
          >
            <mfpc-datepicker
              formField
              [item]="control"
              [form]="controls"
              [formData]="formData"
              [min]="
              item.startDateMathDay || item.startDateMathDay === 0
                  ? mathCurrentDateDay(item.startDateMathDay)
                  : ''
              "
              [max]="
                item.endDateMathDay || item.endDateMathDay === 0
                  ? mathCurrentDateDay(item.endDateMathDay)
                  : form
                      .get(item.formControlName)['controls'][i]
                      .get(control.endDateControl)?.value
              "
            ></mfpc-datepicker>
          </div>

          <div
            class="custom-form-field"
            *ngIf="control.type === 'datepicker-range-end'"
            [ngClass]="control.gridClasses"
          >
            <mfpc-datepicker
              formField
              [item]="control"
              [form]="controls"
              [formData]="formData"
              [min]="
              control.startDateMathDay || control.startDateMathDay === 0
                  ? mathCurrentDateDay(control.startDateMathDay)
                  : form
                      .get(item.formControlName)['controls'][i]
                      .get(control.startDateControl)?.value
              "
              [max]="
              control.endDateMathDay
                  ? mathCurrentDateDay(control.endDateMathDay)
                  : ''
              "
            ></mfpc-datepicker>
          </div>
        </ng-container>
      </div>

      <div class="custom-form-array__row-tools tools">
        <button
          pButton
          icon="pi pi-times"
          class="p-button-rounded p-button-text p-button-plain"
          type="button"
          (click)="removeSmartFormGroup(item.formControlName, i)"
        ></button>
      </div>
    </div>
  </ng-container>

  <div class="custom-form-array__add-row button-wrap">
    <button
      pButton
      icon="pi pi-plus"
      class="p-button-text p-button-plain"
      type="button"
      iconPos="left"
      label="{{ item.label }}"
      (click)="addSmartFormGroup(item.formControlName)"
    ></button>
  </div>
</div>
